import { create } from "zustand";
import AuthState from "../types/AuthState";
import { checkTokenApi } from "../services/admin/auth";

export const useAuthStore = create<AuthState>()((set) => ({
	user: null,
	token: localStorage.getItem("discovery-auth-token"),
	isAuthenticated: false,
	isLoading: true,
	login: async (token, user) => {
		set({ token, user, isAuthenticated: true });
	},
	logout: () => {
		localStorage.removeItem("discovery-auth-token");
		set({ token: null, user: null, isAuthenticated: false });
	},
	checkAuth: async () => {
		set({ isLoading: true });

		const savedToken = localStorage.getItem("discovery-auth-token");
		if (!savedToken) {
			set({
				token: null,
				user: null,
				isAuthenticated: false,
				isLoading: false,
			});
			return;
		}

		try {
			const { user } = await checkTokenApi(savedToken);
			set({ token: savedToken, user, isAuthenticated: true, isLoading: false });
		} catch (err) {
			console.warn("Token inválido ou expirado:", err);
			localStorage.removeItem("discovery-auth-token");

			set({
				token: null,
				user: null,
				isAuthenticated: false,
				isLoading: false,
			});
		}
	},
}));
